module.exports = __webpack_public_path__ + "img/gmri-sst-1988-tracing-18-25.d4464ffb.png";